export default __webpack_public_path__ + "static/media/2.12de794e.jpeg";